<div class="vertical-stepper" [ngClass]="{ 'vertical-stepper': isVertical, 'horizontal-stepper': !isVertical}" #stepperContainer>
  <ng-container *ngFor="let step of steps; let i = index">
    <div class="step" [ngClass]="{ 'active': step.isActive || (showCompletedSteps && step.isdone), 'partial': showCompletedSteps && step.isPartial && !step.isdone, 'current': step.isCurrent }" (click)="toggleStep(i, step)" #stepElement>
      <div class="step-number">
        <span>{{ i + 1 }}</span>
      </div>
      <div class="step-content" [tooltip]="step.title | translate" placement="top">
        {{step.title | translate}}
      </div>
    </div>
    <div class="step-divider" [ngClass]="{ 'active': step.isActive || (showCompletedSteps && step.isdone), 'partial': showCompletedSteps && step.isPartial && !step.isdone }" *ngIf="i !== steps.length - 1"></div>
  </ng-container>
</div>